"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTER_LINK = exports.LOGIN_LINK = void 0;
const LOGIN_LINK = exports.LOGIN_LINK = 'login-link';
const REGISTER_LINK = exports.REGISTER_LINK = 'register-link';
